import { useState } from 'react';
import { DivPaperStyled, ModalStyled, Title } from '../../../components/Modals.styled';
import { KTSVG } from '../../../../_metronic/helpers';
import { modalStyles } from '../../../components/ModalStyles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../setup';
import { InputStyled } from '../../../components/Inputs.styled';
import { Backdrop, Fade, Checkbox, FormGroup, FormControlLabel, TextField, Dialog, Alert } from '@mui/material';
import axios from 'axios'

const SET_VENDORS = '/api/v1/database/vendor'

const VendorCollectModal = ({open, setOpen, formik}) => {
    const classes = modalStyles({})
    const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
    const [remarksChecked, setRemarksChecked] = useState(false)
    const [isUpdated, setIsUpdated] = useState(false)

    const handleClose = () => {
        setOpen(false)
    }

    const saveCarrier = (data) => {
        axios.post(`${SET_VENDORS}`, {            
            name: data.name,
            bookingRemarks: remarksChecked ? data.collectNotes : '',
            bookingRemarksForce: remarksChecked,
            SCAC: data.SCAC,
            collectCarrier: data.collectCarrier
        }).then((response) => {
            let results = response.data.data.results
            if(results) {
                formik.setFieldValue('selectedVendorCollect', results?.name)
                formik.setFieldValue('collectVendorName', results?.name)
                formik.setFieldValue('collectVendorId', results?.id)
                formik.setFieldValue('specialInstructions', formik?.values?.specialInstructions?.concat("\r\n\r\n", results.bookingRemarks?.replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/g, " ").replace(/&quot;/g, '"').replace(/&amp;/g, "&")))
                
                setIsUpdated(true)
                
                handleClose()
            }
        }).catch(error => {
            console.log(error)
        })
    }

    return (
        <>
      <ModalStyled
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        fontSize={fontSize}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
        timeout: 500,
        }}
      >
        <Fade in={open}>
            <DivPaperStyled className={classes.paper}>
                <div className="row modal-header p-0 pb-2 mb-5">
                    <div className="col-8">
                        <h5 className="modal-title">Collect Vendor Setup</h5>
                    </div>
                    <div className="col-1 d-flex btn btn-icon btn-sm btn-active-light-primary me-3" onClick={() => setOpen(false)}>
                        <KTSVG
                            path="/media/icons/duotune/arrows/arr061.svg"
                            className="svg-icon svg-icon-2x" 
                        />
                    </div>
                </div>
                <>
                <div className='row'>
                    <div className="col-6 col-sm-6">
                        <div className="col-12 col-sm-1">
                            <label className='form-label'>Name</label>
                        </div>                                   
                        <div className="col-12 col-sm-12 mb-5 mb-sm-0">
                            <InputStyled
                                type="text"
                                className="form-control"
                                autoComplete='off'
                                name='selectedVendorCollect'
                                {...formik.getFieldProps('selectedVendorCollect')}
                                style={{ 
                                    borderColor: formik?.errors?.selectedVendorCollect && formik?.touched?.selectedVendorCollect ? '#F1416C' : '#E4E6EF'
                                }}
                                fontSize={fontSize}
                            />
                            {
                                formik?.errors?.name && formik?.touched?.name &&
                                <small className='text-danger'>{formik?.errors.name}</small>
                            }
                        </div>
                    </div>
                    <div className="col-6 col-sm-6">
                        <div className="col-12 col-sm-1">
                            <label className='form-label'>SCAC</label>
                        </div>                                   
                        <div className="col-12 col-sm-12 mb-5 mb-sm-0">
                            <InputStyled
                                type="text"
                                className="form-control"
                                autoComplete='off'
                                name='vendorSCAC'
                                {...formik.getFieldProps('vendorSCAC')}
                                style={{ 
                                    borderColor: formik?.errors?.vendorSCAC && formik?.touched?.vendorSCAC ? '#F1416C' : '#E4E6EF'
                                }}
                                fontSize={fontSize}
                            />
                            {
                                formik?.errors?.name && formik?.touched?.name &&
                                <small className='text-danger'>{formik?.errors.name}</small>
                            }
                        </div>
                    </div>
                </div>  
                <div className='row my-5'>
                    <div className="col-12 col-sm-12">
                       <FormGroup>
                            <FormControlLabel name='collectShowRemarks' control={<Checkbox onChange={(e) => setRemarksChecked( e.target.checked)}/>} label="Show these remarks on the BOL" />
                        </FormGroup>
                    </div>
                    <div className='col-12 col-sm-12'>
                        <TextField
                            id="outlined-multiline-flexible"
                            name='notes'
                            placeholder='Type a message'
                            sx={{ width: '100%', backgroundColor: '#FFFFFF', '& .MuiInputBase-inputMultiline': {height: 'auto !important' } }}
                            multiline
                            name='collectNotes'
                            {...formik.getFieldProps('collectNotes')}
                            // onChange={formik.handleChange}
                            maxRows={8}
                        />
                    </div>
                </div>                                              
                <div className="row mt-3 mb-3">
                    <div className="col-12 d-flex justify-content-end">
                        <button
                            className="btn btn-primary mx-5"                            
                            type="submit"
                            onClick={() => {
                                saveCarrier({
                                    name: formik?.values?.selectedVendorCollect,
                                    SCAC: formik?.values?.vendorSCAC,
                                    collectShowRemarks: formik?.values?.collectShowRemarks,
                                    collectNotes: formik?.values?.collectNotes,
                                    collectCarrier: true
                                })
                            }}
                        >
                            Save Carrier
                        </button>
                        <button
                            className="btn btn-secondary"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
                        {/* <RemarksMessageModal
                            open={openRemarksMessageModal}
                            setOpen={setOpenRemarksMessageModal}
                            formik={formik}
                        /> */}
                </>
            </DivPaperStyled>
        </Fade>
    </ModalStyled>
    <Dialog open={isUpdated}>
        <Alert
        //   sx={{
        //     width: '{obj.width}',
        //     margin: '{obj.margin}',
        //   }}
        //   severity={obj.severity}
        //   color={obj.severity}
          onClose={() => setIsUpdated(false)}
        >
          {/* <AlertTitle>{obj.title}</AlertTitle>
          {obj.message} */}
          <p>Account saved</p>
          <p>Now you can click on Create Shipment</p>
        </Alert>
      </Dialog>
    </>
  )
}

export default VendorCollectModal